import React from 'react';
import { classNames } from '../../../utilities/classNames';

const comparisonItems = [
  { label: 'Unique Visitors', key: 'uniqueVisitors' },
  { label: 'Avg Sip Rating', key: 'avgSipRating' },
  { label: 'Views', key: 'views' },
  { label: 'Check-Ins', key: 'checkins' },
];

function formatValue(value, key) {
  if (value == null) return '--';
  if (key === 'avgSipRating') return value.toFixed(1);
  return value.toLocaleString();
}

export default function RegionalBenchmarkCard({ benchmark }) {
  if (!benchmark) return null;

  const { appellation, peerCount, yourMetrics, avgPeerMetrics, comparison } = benchmark;

  return (
    <div className="bg-white rounded-lg shadow p-5">
      <h4 className="text-base font-semibold text-gray-900">
        You vs {appellation?.name || 'Region'}
      </h4>
      <p className="mt-1 text-sm text-gray-500">
        Compared to {peerCount} peer{peerCount !== 1 ? 's' : ''} in this appellation
      </p>
      <div className="mt-4 grid grid-cols-2 gap-4">
        {comparisonItems.map((item) => {
          const yours = yourMetrics?.[item.key];
          const peerAvg = avgPeerMetrics?.[item.key];
          const diff = comparison?.[item.key];
          const isPositive = diff != null && diff > 0;
          const isNegative = diff != null && diff < 0;

          return (
            <div key={item.key} className="bg-gray-50 rounded-lg p-4">
              <p className="text-xs font-medium text-gray-500 uppercase">{item.label}</p>
              <p className="mt-1 text-xl font-bold text-gray-900">
                {formatValue(yours, item.key)}
              </p>
              <div className="mt-1 flex items-center justify-between">
                <span className="text-xs text-gray-500">
                  Avg: {formatValue(peerAvg, item.key)}
                </span>
                {diff != null && (
                  <span
                    className={classNames(
                      'text-xs font-medium',
                      isPositive ? 'text-green-600' : isNegative ? 'text-red-600' : 'text-gray-500'
                    )}
                  >
                    {isPositive ? '+' : ''}{Math.round(diff)}%
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
